import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueMeta from 'vue-meta';
import dotenv from 'dotenv-flow';

dotenv.config();

Vue.config.productionTip = process.env.NODE_ENV !== 'production';
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.performance = process.env.NODE_ENV !== 'production';

Vue.use(VueMeta);

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
